import { render } from "./PagoOtros.vue?vue&type=template&id=fbd2aa30"
import script from "./PagoOtros.vue?vue&type=script&lang=js"
export * from "./PagoOtros.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__